<template>
    <div>
        <b-row>
            <b-col>
                <h5>Paid Time Off</h5>
            </b-col>

            <b-col align="right">
                <b-dropdown ref="employeeDropdown" no-caret size="sm" variant="link" class="menu-btn" toggle-class="text-decoration-none">
                    <template #button-content>
                        <b-button variant="outline-secondary" size="sm">
                            <b-icon-plus></b-icon-plus>
                        </b-button>
                    </template>

                    <b-input-group style="width: 15rem;" size="sm" class="p-3">
                            <b-input v-model="employee.username" placeholder="Username"></b-input>

                            <b-input-group size="sm">
                                <b-input-group-prepend size="sm">
                                    <b-input disabled value="Available" size="sm"></b-input>
                                </b-input-group-prepend>
                                <b-input v-model="employee.available" placeholder="Available Days" type="number"></b-input>
                            </b-input-group>
                    </b-input-group>


                    <b-row>
                        <b-col align="right" class="mr-3">
                            <b-button size="sm" @click="addEmployee" variant="primary" :disabled="!employee.username">
                                <b-icon-plus-square-fill></b-icon-plus-square-fill>
                                <span class="p-xl-2 pl-2 pr-1">Add</span>
                            </b-button>
                        </b-col>
                    </b-row>
                </b-dropdown>
            </b-col>
        </b-row>

        <b-row>
            <b-col>
                <b-input-group v-for="employee in employees" :key="employee._id" size="sm">
                    <b-input disabled :value="employee.username"></b-input>
                    <b-input disabled value="Available"></b-input>
                    <b-input :value="employee.available" type="number" size="sm" @input="updateAvailable($event, employee)"></b-input>
                    <b-button @click="confirmRemoval(employee.username)" size="sm" variant="outline-secondary">
                        <b-icon-x></b-icon-x>
                    </b-button>
                </b-input-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import timecardApi from "@/api/timecard";

    export default {
        name: "ManagePaidTimeOff",
        mixins: [ timecardApi ],
        data() {
            return {
                employees: [],
                employee: {
                    username: null,
                    available: 0,
                    used: 0,
                }
            }
        },
        async created() {
            await this.getEmployees();
        },
        methods: {
            async getEmployees() {
                this.employees = await this.getPaidTimeOffEmployees();
            },
            async addEmployee() {
                try {
                    await this.createPaidTimeOffEmployee(this.employee.username, this.employee.available);

                    await this.getEmployees();

                    this.$refs.employeeDropdown.hide();
                } catch (err) {
                    let msg = err.response.data && err.response.data.message ? err.response.data.message : err.message;

                    this.$emit('errors', msg);

                    console.log(err);
                }
            },
            async confirmRemoval(username) {
                const confirm = await this.$bvModal.msgBoxConfirm(`Are you sure you want to remove ${username}?`, {
                    title: 'Removal Confirmation',
                    size: 'md',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    // headerClass: 'p-2 border-bottom-0',
                    // footerClass: 'p-2 border-top-0',
                    bodyClass: 'confirm-body',
                    centered: true
                });

                if (confirm) {
                    await this.removeEmployee(username);
                }
            },
            async removeEmployee(username) {
                try {
                    await this.deletePaidTimeOffEmployee(username);

                    await this.getEmployees();
                } catch (err) {
                    let msg = err.response.data && err.response.data.message ? err.response.data.message : err.message;

                    this.$emit('errors', msg);

                    console.log(err);
                }
            },
            async updateAvailable(available, employee) {
                try {
                    await this.updatePaidTimeOffEmployee(employee.username, parseInt(available));
                } catch (err) {
                    let msg = err.response.data && err.response.data.message ? err.response.data.message : err.message;

                    this.$emit('errors', msg);

                    console.log(err);
                }
            }
        }
    }
</script>

<style>
    .confirm-body {
        min-height: auto !important;
    }
</style>